import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ButtonCancelComponent } from './button-cancel/button-cancel.component';
import { ButtonDeleteRoundedComponent } from './button-delete-rounded/button-delete-rounded.component';
import { ButtonEditRoundedComponent } from './button-edit-rounded/button-edit-rounded.component';
import { ButtonNewComponent } from './button-new/button-new.component';
import { ButtonSaveComponent } from './button-save/button-save.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { FormFieldErrorComponent } from './form-field-error/form-field-error.component';
import { CommonsInputsModule } from './inputs/inputs.module';
import { LoaderComponent } from './loader/loader.component';
import { ToasterComponent } from './toaster/toaster.component';
import { ColorSelectorComponent } from './color-selector/color-selector.component';
import { ButtonSelectorComponent } from './button-selector/button-selector.component';
import { TopbarClockComponent } from './topbar-clock/topbar-clock.component';
import { TreeViewComponent } from './tree-view/tree-view.component';
import { TopbarUserMenuComponent } from './topbar-user-menu/topbar-user-menu.component';
import { PostCreateEntityLinksDialogComponent } from './post-create-entity-links-dialog/post-create-entity-links-dialog.component';
import { PostCreateNoticeDialogComponent } from './post-create-notice-dialog/post-create-notice-dialog.component';

@NgModule({
  imports: [
    RouterModule,
    BreadcrumbComponent,
    ButtonCancelComponent,
    ButtonDeleteRoundedComponent,
    ButtonEditRoundedComponent,
    ButtonNewComponent,
    ButtonSaveComponent,
    ConfirmDialogComponent,
    FormFieldErrorComponent,
    LoaderComponent,
    ToasterComponent,
    CommonsInputsModule,
    ColorSelectorComponent,
    ButtonSelectorComponent,
    TreeViewComponent,
    TopbarClockComponent,
    TopbarUserMenuComponent,
    PostCreateEntityLinksDialogComponent,
    PostCreateNoticeDialogComponent,
  ],
  exports: [
    RouterModule,
    BreadcrumbComponent,
    ButtonCancelComponent,
    ButtonDeleteRoundedComponent,
    ButtonEditRoundedComponent,
    ButtonNewComponent,
    ButtonSaveComponent,
    ConfirmDialogComponent,
    FormFieldErrorComponent,
    LoaderComponent,
    ToasterComponent,
    ColorSelectorComponent,
    ButtonSelectorComponent,
    TreeViewComponent,
    TopbarClockComponent,
    TopbarUserMenuComponent,
    PostCreateEntityLinksDialogComponent,
    PostCreateNoticeDialogComponent,
  ],
})
export class CommonComponentsModule {}
